/**
 * Content pages deliberately keep their build-time article as the whole page.
 * Only atlas documents expose a React root. Production atlas routes may place
 * a stable first-frame shell inside it; content routes are marked prerendered
 * and must never be replaced by the map runtime.
 */
export function applicationMountElement(documentRef: Document): HTMLElement | null {
  const root = documentRef.getElementById('root')
  if (!root || root.hasAttribute('data-prerendered')) return null
  return root
}

export function initializeApplicationMount(
  documentRef: Document,
  mount: (element: HTMLElement) => void,
): boolean {
  const element = applicationMountElement(documentRef)
  if (!element) return false
  mount(element)
  return true
}
